module.exports = __webpack_public_path__ + "static/media/section2.99f9267b.jpg";